import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LogoutButton from './Login/LogoutButton';

import { actionCreators as AppSettingsActions } from '../Store/AppSettings';
import { actionCreators as UIStateActions, GetPortalBusyState } from '../Store/UIState';
import { actionCreators as UserActions, GetAuth0LoggingOut } from '../Store/User';

import { LoadingIndicator } from './LoadingIndicator/LoadingIndicator';

import { 
    GetPortalText,
    RetrieveTimeoutText,
} from '../Store/PortalAssets';

import { 
    PortalTextTimeoutMessaging
} from '../Models/Api/strongbox.financialportal';

import { ApplicationState } from '../Store';

type InjectedReduxState = {
    timeoutMessaging?: PortalTextTimeoutMessaging;
    portalBusy: boolean;
    loggingOut: boolean;
}

type InjectedActionCreators = typeof AppSettingsActions & typeof UserActions & typeof UIStateActions;

type AuthTimedOutProps = {
};

type Props = AuthTimedOutProps & InjectedActionCreators & InjectedReduxState;

const AuthTimedOutComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        loggingOut,
        timeoutMessaging,
        SetSessionInfo,
        SetLoggedInUser,
        SetPortalIdle,
        SetPortalWorking,
        portalBusy,
    } = props;

    React.useEffect(() => {
        // immediately call this to clear the auth0 token from redux store
        // and session storage.

        SetLoggedInUser();
        SetSessionInfo(undefined, []);

        const workingMsg = 'AuthTimedOut:GettingContent';

        SetPortalWorking(workingMsg);
        RetrieveTimeoutText()
            .catch(() => {})
            .finally(() => { SetPortalIdle(workingMsg); })


        // I want this to execute equivalent to componentDidMount so this is appropriate
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const paragraphs: React.ReactNode[] = React.useMemo(() => {
        const result: React.ReactNode[] = [];

        if (!!timeoutMessaging) {
            timeoutMessaging.authTimeout.forEach((paragraph, index) => {
                result.push((
                    <h3 key={`timedOutParagraph${index}`} style={{ marginTop: '20px' }}>{paragraph}</h3>
                ));
            });
        }

        return result;
    }, [timeoutMessaging])

    return (
        <>
            {
                !!loggingOut && (
                    <div style={{ position: 'absolute', width: '100%' }} className={`free-content-region control-region control-region-lender`}>
                        <LoadingIndicator active={portalBusy} centerIndicator={true} />
                        <div style={{ height: '100%' }} className={'contained-content'}>
                            <h1>{timeoutMessaging?.loggingOut || ''}</h1>
                        </div>
                    </div>
                )
            }
            {
                !loggingOut && (
                    <div className={`full-screen-region lender-region content-region control-region control-region-lender`}>
                        <LoadingIndicator active={portalBusy} centerIndicator={true} />
                        <div>
                            {paragraphs}
                            <LogoutButton style={{ marginTop: '40px' }} buttonText={timeoutMessaging?.returnToLogin || ''} />
                        </div>
                    </div>
                )
            }
        </>
    )
}

export const AuthTimedOut = connect<InjectedReduxState, InjectedActionCreators, AuthTimedOutProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            timeoutMessaging: GetPortalText<PortalTextTimeoutMessaging>(appState, 'timeoutMessaging'),
            loggingOut: GetAuth0LoggingOut(appState),
            portalBusy: GetPortalBusyState(appState),
        };

        return result;
    }, 
    dispatch => bindActionCreators(
        {
        ...UserActions,
        ...AppSettingsActions,
        ...UIStateActions,
        },
        dispatch
    )
)(AuthTimedOutComponent);
